module.exports = __webpack_public_path__ + "img/logo-energySavings.624cb165.svg";